// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invoice-wrapper {
  display: flex;
  justify-content: center;
  padding-top: 40px;
  font-family: Arial, sans-serif;
}

.invoice-card {
  width: 600px;
  background: white;
  padding: 25px;
  border-radius: 12px;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.1);
}

.title {
  text-align: center;
  margin-bottom: 20px;
  color: #222;
  font-weight: bold;
}

.input-row {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-bottom: 20px;
}

.input-select {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 15px;
}

.btn-generate {
  background: #007bff;
  color: white;
  padding: 10px 18px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 15px;
}

.btn-generate:disabled {
  background: #7da7e1;
  cursor: not-allowed;
}

.spinner {
  border: 3px solid #fff;
  border-top: 3px solid #004a99;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  animation: spin 0.6s linear infinite;
  margin: auto;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.progress-box {
  background: #f5f5f5;
  padding: 12px;
  border-radius: 8px;
}

.progress-bar {
  margin-top: 8px;
  height: 6px;
  border-radius: 6px;
  background: linear-gradient(90deg, #007bff, #00c6ff);
  animation: load 1.5s infinite;
}

@keyframes load {
  0% { width: 10%; } 
  100% { width: 90%; }
}

.result-box {
  margin-top: 20px;
  background: #fafafa;
  padding: 15px;
  border-radius: 8px;
}
.logout-container {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.btn-logout {
  background: #ff4d4d;
  border: none;
  padding: 8px 14px;
  border-radius: 6px;
  color: white;
  cursor: pointer;
  font-weight: 600;
  transition: 0.3s ease;
}

.btn-logout:hover {
  background: #cc0000;
}`, "",{"version":3,"sources":["webpack://./src/components/invoice.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,oDAAoD;EACpD,6BAA6B;AAC/B;;AAEA;EACE,KAAK,UAAU,EAAE;EACjB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".invoice-wrapper {\r\n  display: flex;\r\n  justify-content: center;\r\n  padding-top: 40px;\r\n  font-family: Arial, sans-serif;\r\n}\r\n\r\n.invoice-card {\r\n  width: 600px;\r\n  background: white;\r\n  padding: 25px;\r\n  border-radius: 12px;\r\n  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.title {\r\n  text-align: center;\r\n  margin-bottom: 20px;\r\n  color: #222;\r\n  font-weight: bold;\r\n}\r\n\r\n.input-row {\r\n  display: flex;\r\n  gap: 12px;\r\n  justify-content: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.input-select {\r\n  padding: 10px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 6px;\r\n  font-size: 15px;\r\n}\r\n\r\n.btn-generate {\r\n  background: #007bff;\r\n  color: white;\r\n  padding: 10px 18px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 15px;\r\n}\r\n\r\n.btn-generate:disabled {\r\n  background: #7da7e1;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.spinner {\r\n  border: 3px solid #fff;\r\n  border-top: 3px solid #004a99;\r\n  border-radius: 50%;\r\n  width: 16px;\r\n  height: 16px;\r\n  animation: spin 0.6s linear infinite;\r\n  margin: auto;\r\n}\r\n\r\n@keyframes spin {\r\n  to { transform: rotate(360deg); }\r\n}\r\n\r\n.progress-box {\r\n  background: #f5f5f5;\r\n  padding: 12px;\r\n  border-radius: 8px;\r\n}\r\n\r\n.progress-bar {\r\n  margin-top: 8px;\r\n  height: 6px;\r\n  border-radius: 6px;\r\n  background: linear-gradient(90deg, #007bff, #00c6ff);\r\n  animation: load 1.5s infinite;\r\n}\r\n\r\n@keyframes load {\r\n  0% { width: 10%; } \r\n  100% { width: 90%; }\r\n}\r\n\r\n.result-box {\r\n  margin-top: 20px;\r\n  background: #fafafa;\r\n  padding: 15px;\r\n  border-radius: 8px;\r\n}\r\n.logout-container {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.btn-logout {\r\n  background: #ff4d4d;\r\n  border: none;\r\n  padding: 8px 14px;\r\n  border-radius: 6px;\r\n  color: white;\r\n  cursor: pointer;\r\n  font-weight: 600;\r\n  transition: 0.3s ease;\r\n}\r\n\r\n.btn-logout:hover {\r\n  background: #cc0000;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
